<template>
  <div class="management-page-outer-container">
    <router-view />
    <div
      v-if="$route.name === 'workspaces-management'"
      class="data-table management-main-list-data-table"
    >
      <workspace-data-table
        :pagination-from-parent="pagination"
        @update-pagination="pagination = $event"
        :search-from-parent="search"
        @update-search="search = $event"
      >
        <management-add-button
          :label="$t('AddWorkspace')"
          @buttonClick="$router.push({ name: 'workspace-create' })"
          :disabled="!hasNeededPermissionsTo(addButtonMissingPermissions)"
          :listMissingPermissions="addButtonMissingPermissions"
        />
      </workspace-data-table>
    </div>
  </div>
</template>

<script>
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import WorkspaceDataTable from "@/components/ProjectManagement/Workspaces/WorkspaceDataTable";
import ManagementAddButton from "@/components/Management/ManagementAddButton";

export default {
  name: "WorkspacesPage",

  components: {
    ManagementAddButton,
    WorkspaceDataTable
  },

  mixins: [checkPermissionsMixin],

  data() {
    return {
      pagination: null,
      search: ""
    };
  },

  computed: {
    addButtonMissingPermissions() {
      let neededPermissions = [
        "workspace_store",
        "network_rule_list",
        "workspace_network_rule_store",
        "labelling_rule_list",
        "workspace_labelling_rule_store"
      ];
      return this.getMissingPermissionsList(neededPermissions);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ProjectManagement/Workspaces/Workspace.vue